import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  isLikeCompatibilityEnabled,
  isSemanticSearchModeBadgeEnabled,
  isSemanticSearchModuleEnabled,
} from '../../app/helpers/semanticSearchConfigHelper';

/**
 * Indicador junto a "Resultados obtenidos".
 * Visible solo si master + flag del módulo están ON (misma condición que el backend híbrido).
 */
const SemanticSearchModeBadge = ({ moduleKey }) => {
  const { t } = useTranslation();
  const configuration = useSelector((state) => state.configuration);

  if (!moduleKey || !isSemanticSearchModuleEnabled(configuration, moduleKey)) {
    return null;
  }
  if (!isSemanticSearchModeBadgeEnabled(configuration)) {
    return null;
  }

  const likeCompat = isLikeCompatibilityEnabled(configuration);
  const label = likeCompat
    ? t('semanticSearch.modeHybrid')
    : t('semanticSearch.modeSemantic');

  return (
    <div className="semantic-search-mode-badge" title={t('semanticSearch.modeHint')}>
      {label}
    </div>
  );
};

export default SemanticSearchModeBadge;
